<template>
  <div class="battery-screen-wapper">
    <div class="battery-screen-oneji" v-for="item in typelist" :key="item.key">
      <p>{{item.name}}</p>
      <div v-for="n in item.infoDTOList" :key="n.key">
        <div v-if="n.infoDTOList">
          <van-collapse v-model="activeNames">
            <van-collapse-item :name="n.id">
              <div slot="title">{{n.name}}</div>
              <div class="battery-screen-twoe">
                <div v-for="i in n.infoDTOList" :key="i.key">{{i.name}}</div>
              </div>
            </van-collapse-item>
          </van-collapse>
        </div>
      </div>
      <div v-for="n in item.infoDTOList" :key="n.key" class="battery-screen-onejil">
        <div v-if="n.infoDTOList==undefined">
          <div>{{n.name}}</div>
        </div>
      </div>
    </div>
    <!-- <div class="battery-screen-twoji">
      <p>正负极材料</p>
      <van-collapse v-model="activeNames">
        <van-collapse-item>
          <div slot="title">三元正级片</div>
          <div class="battery-country-li">
            <div>
              <div>三元正级片</div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>-->
  </div>
</template>

<script>
export default {
  name: "screen",
  data() {
    return {
      activeNames: ["1"],
      typelist: "",
      comments: [],
      showPage: 1,
      pageSize: 10,
      pageindex: 1,
      loading: false,
      finished: false,
      totalElements: "",
      aloading: true
    };
  },
  created() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.$axios
        .get("/micro/permission_goods/goods/read/queryList")
        .then(res => {
          this.aloading = false;
          this.typelist = res.data.data;
          console.log(res.data.data);
        }); // 异步更新数据
      setTimeout(() => {
        // 异步滑动加载数据
        this.getMore(); // 加载状态结束
        this.loading = false;
        if (this.comments.length >= this.totalElements) {
          this.finished = true;
        }
      }, 2000);
    },

    getMore() {
      this.pageindex++;
    },
    getNews(item, i) {
      this.$router.push({ path: "/supplyform", query: { xqid: item } });
    }
  }
};
</script>

<style scoped>
.battery-screen-wapper {
  text-align: left;
}
.battery-screen-oneji > p {
  padding: 15px 20px;
  background: #f7f8fa;
  font-size: 16px;
  font-weight: bold;
  color: #222;
}
.battery-screen-twoji > p {
  padding: 15px 20px;
  background: #f7f8fa;
  font-size: 16px;
  font-weight: bold;
  color: #222;
}
.battery-screen-oneji .battery-screen-onejil {
  width: 30%;
  display: inline-block;
  text-align: center;
  margin: 5px 4px;
  font-size: 14px;
}
.battery-screen-twoe > div {
  width: 30%;
  display: inline-block;
  text-align: center;
  margin: 5px 4px;
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/view/screen.vue